import React from "react";

const DeleteCandidateModal = ({ open, onClose, onConfirm }) => {
  return (
    <>
      <div
        className={`modal fade ${open ? "show" : ""}`}
        tabIndex="-1"
        style={{
          display: open ? "block" : "none",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ backgroundColor: "#A7A7A7" }}>
            <div className="modal-header border-0">
              <h5 className="modal-title fw-bold" style={{ color: "#1E1E1E" }}>
                Delete The candidate
              </h5>

              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <span className="fw-normal" style={{ color: "#1E1E1E" }}>
                Are you sure you want to delete the candidate? <br />
                <div style={{ marginBottom: "10px" }}></div>
                Deleting a candidate will permanently remove them from the system.
                This action is reversible.
              </span>
            </div>
            <div className="modal-footer d-flex flex-column justify-content-center border-0">
              <button
                type="button"
                className="btn rounded-2 fw-medium w-50"
                style={{ backgroundColor: "#1E1E1E", color: "#E8E8E8" }}
                onClick={onConfirm}
              >
                Delete candidate
              </button>
              <button
                type="button"
                className="btn rounded-2 fw-medium w-50"
                onClick={onClose}
                style={{ backgroundColor: "#FEFEFE", color: "#1E1E1E" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteCandidateModal;